import { render } from "./TechInfoContainer.vue?vue&type=template&id=0dac7032"
import script from "./TechInfoContainer.vue?vue&type=script&lang=js"
export * from "./TechInfoContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__